import { createStore } from 'zustand';
import type { StoreApi } from 'zustand';

import appConstants from '@/constants/appConstants';

import type { Issue } from '../types/Issue';

export type IssuesState = {
    selectedIssues: Issue[];
    vehicleId: string | null;
};

export type IssuesActions = {
    updateSelectedIssues: (issues: IssuesState['selectedIssues']) => void;
    updateVehicleId: (vehicleId: IssuesState['vehicleId']) => void;
    resetStore: () => void;
};

export type IssuesStore = IssuesState & IssuesActions;

export const initialState: IssuesState = {
    selectedIssues: [],
    vehicleId: null,
};

export function getStoredState(): IssuesState {
    if (typeof window === 'undefined') return initialState;

    const storedIssues = sessionStorage.getItem(appConstants.selectedIssuesStorageName);
    const storedVehicleId = sessionStorage.getItem(appConstants.vehicleIdStorageName);

    return {
        selectedIssues: storedIssues ? (JSON.parse(storedIssues) as Issue[]) : [],
        vehicleId: storedVehicleId ? (JSON.parse(storedVehicleId) as string | null) : null,
    };
}

export function createIssuesStore(issuesState: IssuesState = getStoredState()): StoreApi<IssuesStore> {
    return createStore<IssuesStore>()((set) => ({
        ...issuesState,
        updateSelectedIssues: (issues): void => {
            sessionStorage.setItem(appConstants.selectedIssuesStorageName, JSON.stringify(issues));
            set(() => ({ selectedIssues: issues }));
        },
        updateVehicleId: (vehicleId): void => {
            sessionStorage.setItem(appConstants.vehicleIdStorageName, JSON.stringify(vehicleId));
            set(() => ({ vehicleId }));
        },
        resetStore: (): void => {
            sessionStorage.removeItem(appConstants.selectedIssuesStorageName);
            sessionStorage.removeItem(appConstants.vehicleIdStorageName);
            set(initialState);
        },
    }));
}
